"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportTextIssues = ExportTextIssues;
const React = __importStar(require("react"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const GraphQLTypes = __importStar(require("@genesys/graphql-types-tools"));
// interface Issue {
//   readonly productKey: string;
//   readonly propertyName: string;
//   readonly type: GraphQLTypes.ErrorAndWarningType;
//   readonly params: {
//     readonly propertyValue?: number | null;
//     readonly languages: ReadonlyArray<string>;
//   };
// }
// enum ErrorAndWarningType {
//   PROPERTY_NON_STANDARD_TRANSLATION_WARNING,
//   PROPERTY_MISSING_DEFAULT_LANGUAGE_STANDARD_TRANSLATIONS,
//   PROPERTY_MULTIPLE_STANDARD_TRANSLATION,
//   PROPERTY_UNNECESSARY_TRANSLATION,
//   PROPERTY_DIFFERENT_STANDARD_TRANSLATIONS,
//   PROPERTY_TYPE_WARNING,
//   // PropertyValues
//   PROPERTY_VALUE_NON_STANDARD_TRANSLATION_WARNING,
//   PROPERTY_VALUE_MISSING_DEFAULT_LANGUAGE_STANDARD_TRANSLATIONS,
//   PROPERTY_VALUE_MULTIPLE_STANDARD_TRANSLATION,
//   PROPERTY_VALUE_UNNECESSARY_TRANSLATION,
//   PROPERTY_VALUE_DIFFERENT_STANDARD_TRANSLATIONS
// }
function ExportTextIssues({ data, disabled, fileName }) {
    const errorAndWarningTypes = GraphQLTypes.ErrorAndWarningType;
    const FixableIssues = [
        errorAndWarningTypes.PROPERTY_UNNECESSARY_TRANSLATION,
        errorAndWarningTypes.PROPERTY_VALUE_UNNECESSARY_TRANSLATION
    ];
    const filteredData = data.filter(x => FixableIssues.includes(x.type));
    if (filteredData.length === 0) {
        return null;
    }
    const downloadJson = () => {
        const jsonStr = JSON.stringify(filteredData);
        const blob = new Blob([jsonStr], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${fileName}.json`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return (React.createElement(Elements.StandardButton, { disabled: disabled, onClick: downloadJson }, "Export Text Issues For Promaster"));
}
//# sourceMappingURL=export-text-issues.js.map